import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { STORAGE_URL } from "../constants";

const Root = styled("div")(({ height, theme, width, full, logo }) => {
  return {
    alignItems: "center",
    paddingInline: "20px",
    // backgroundColor: "#D8D5CD",
    backgroundImage: `url(${STORAGE_URL}bayc-3d/btnBg.png)`,

    backgroundRepeat: "no-repeat",
    overflow: "hidden",
    height: height || "65px",
    width: width,
    cursor: "var(--pointer-cursor)",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    [theme.breakpoints.down("sm")]: {
      paddingInline: "5px",
      height: "45px",
    },

    "& .MuiTypography-root": {
      fontWeight: "600",
      textTransform: "capitalize",
      fontFamily: "var(--font-g)",
      fontSize: "22px",
      color: "#000",
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
      },
    },
  };
});

const CustomButton = ({
  title,
  onClick,
  className,
  type,
  size,
  full,
  outline,
  logoPosition = "right",
  logo,
  loading,
  height,
  width,
  style,
  ...rest
}) => {
  const theme = useTheme();
  return (
    <Root
      style={{}}
      full={full}
      width={width}
      height={height}
      className={className}
      logo={logo}
    >
      <Box
        // size={size}
        onClick={onClick}
        {...rest}
      >
        {logo && logoPosition === "left" && logo}
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Typography sx={{ color: "black" }}>{title}</Typography>
        )}
        {logo && logoPosition === "right" && logo}
      </Box>
    </Root>
  );
};

export default CustomButton;
